/**
 * @param data Array data
 * @param id Item's ID
 * @returns A function that receives an "id" to find the item
 */
export const findById =
  <D>(data: Array<D>) =>
  <I>(id: I) =>
    data.find((i) => (i as Record<string, unknown>)?.id === id);

export const getOptionsSelect = <T>({
  data,
  keyLabel,
  keyValue,
  keySubLabel,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;
  keyLabel: string;
  keySubLabel?: string;
  keyValue: string;
}) => {
  return (
    (Array.isArray(data) &&
      data?.map((item) => ({
        label:
          (item[keyLabel] as string) +
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          (keySubLabel ? ` (${item[keySubLabel]})` : ""),
        value: item[keyValue] as T,
        original: item,
      }))) ||
    ([] as { label: string; value: T }[])
  );
};
